<!--
  IconButton — small icon-only button with hover ring + active glow.
  Used for header tools, viewport overlay chips, etc.
-->
<script lang="ts">
  interface Props {
    onclick?: (e: MouseEvent) => void;
    active?: boolean;
    disabled?: boolean;
    title?: string;
    variant?: 'subtle' | 'solid';
    size?: number; // px
    children?: import('svelte').Snippet;
  }
  let {
    onclick,
    active = false,
    disabled = false,
    title,
    variant = 'subtle',
    size = 32,
    children
  }: Props = $props();
</script>

<button
  type="button"
  class="icon-btn {variant}"
  class:active
  style="--btn-size: {size}px"
  {disabled}
  {title}
  aria-label={title}
  aria-pressed={active}
  onclick={(e) => { if (!disabled) onclick?.(e); }}
>
  {#if children}{@render children()}{/if}
</button>

<style>
  .icon-btn {
    width: var(--btn-size); height: var(--btn-size);
    display: inline-flex; align-items: center; justify-content: center;
    border-radius: 9px;
    border: 1px solid transparent;
    background: transparent;
    color: var(--text-2, #c6e1ff);
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.18s ease, transform 0.12s ease;
    position: relative;
  }
  .icon-btn:hover:not(:disabled) {
    background: rgba(255,255,255,0.06);
    color: var(--text-bright, #fff);
    border-color: rgba(255,255,255,0.10);
  }
  .icon-btn:active:not(:disabled) { transform: scale(0.96); }
  .icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }

  .icon-btn.active {
    background: linear-gradient(180deg, rgba(26,122,201,0.28), rgba(26,122,201,0.18));
    color: #d6ecff;
    border-color: rgba(74, 184, 255, 0.45);
    box-shadow:
      0 0 0 1px rgba(74,184,255,0.18) inset,
      0 4px 14px -4px rgba(74,184,255,0.45);
  }

  .solid {
    background: rgba(255,255,255,0.04);
    border-color: rgba(255,255,255,0.06);
  }
</style>
